import React, { memo } from 'react';
import { motion } from 'framer-motion';
const tomos = [{
  icon: '🧩',
  number: 'Tomo 1',
  title: 'Memoria en Acción',
  desc: 'Actividades, fichas y juegos para trabajar memoria visual, auditiva y secuencial.',
  includes: 'Incluye propuestas listas para imprimir, variantes por dificultad y plantillas de seguimiento.'
}, {
  icon: '🎯',
  number: 'Tomo 2',
  title: 'Atención y Foco',
  desc: 'Recursos para estimular atención, concentración, observación y control atencional.',
  includes: 'Incluye actividades graduadas, material imprimible y herramientas para registrar avances.'
}, {
  icon: '💬',
  number: 'Tomo 3',
  title: 'Lenguaje en Juego',
  desc: 'Tarjetas, fichas y propuestas para ampliar vocabulario, comprensión y expresión oral.',
  includes: 'Incluye actividades listas para aplicar y plantillas para acompañar el proceso.'
}, {
  icon: '✏️',
  number: 'Tomo 4',
  title: 'Lectoescritura Práctica',
  desc: 'Ejercicios y recursos para leer, escribir y fortalecer la comprensión.',
  includes: 'Incluye material secuenciado, actividades imprimibles y formatos de seguimiento.'
}, {
  icon: '🔢',
  number: 'Tomo 5',
  title: 'Mente Matemática',
  desc: 'Actividades para número, conteo, lógica, relaciones y razonamiento matemático.',
  includes: 'Incluye propuestas listas para usar, variantes por nivel y registro de avances.'
}, {
  icon: '🧠',
  number: 'Tomo 6',
  title: 'Funciones Ejecutivas',
  desc: 'Recursos para trabajar planificación, organización, flexibilidad y autocontrol.',
  includes: 'Incluye actividades aplicables, materiales de apoyo y plantillas para observación y seguimiento.'
}];
export function TomosGrid() {
  return <section className="py-20 bg-white" data-id="element-254">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-256">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-100 text-brand-800 font-bold text-sm mb-4" data-id="element-257">
            Colección completa · 6 Tomos
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-258">
            Lo que recibís hoy mismo
          </h2>
          <p className="text-xl text-gray-600" data-id="element-259">
            Material profesional, secuenciado y listo para imprimir.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-260">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:border-brand-300 transition-colors group" data-id="element-261">
              <div className="text-4xl mb-4 group-hover:scale-110 transition-transform origin-left" data-id="element-262">
                {tomo.icon}
              </div>
              <div className="text-brand-600 font-bold text-sm uppercase tracking-wider mb-2" data-id="element-263">
                {tomo.number}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-264">
                {tomo.title}
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-265">{tomo.desc}</p>
              <div className="bg-brand-50 p-4 rounded-xl text-sm text-brand-800 font-medium" data-id="element-266">
                {tomo.includes}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}